import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
const API_BASE_URL = process.env.REACT_APP_API_URL;
const StateList = () => {
  const [states, setStates] = useState([]);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  // Permissions
  const userPermissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const canRead = userPermissions.includes("read_State");
  const canCreate = userPermissions.includes("create_State");
  const canEdit = userPermissions.includes("update_State");
  const canDelete = userPermissions.includes("delete_State");

  const fetchStates = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/states`);
      setStates(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (canRead) {
      fetchStates();
    }
  }, [canRead]);

  const handleDelete = async (id) => {
    if (!canDelete) {
      alert("You do not have permission to delete.");
      return;
    }
    if (window.confirm('Delete this state?')) {
      await axios.delete(`${API_BASE_URL}/api/states/${id}`);
      fetchStates();
    }
  };

  const toggleStatus = async (id) => {
    if (!canEdit) {
      alert("You do not have permission to change status.");
      return;
    }
    await axios.patch(`${API_BASE_URL}/api/states/status/${id}`);
    fetchStates();
  };

  if (!canRead) {
    return (
      <div className="container py-5 text-center text-danger">
        <h4>🚫 You do not have permission to view state data.</h4>
      </div>
    );
  }

  const renderTooltip = (msg) => (
    <Tooltip id="button-tooltip">{msg}</Tooltip>
  );

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between mb-3">
        <h3>State List</h3>

        <OverlayTrigger
          placement="top"
          overlay={renderTooltip(canCreate ? "Add State" : "No permission to add")}
        >
          <span className="d-inline-block">
            <button
              className="btn"
              onClick={() => canCreate ? navigate('/add-state') : alert("No permission to add")}
              style={{
                backgroundColor: canCreate ? '#0d1b33' : '#ccc',
                color: canCreate ? 'white' : '#666',
                cursor: canCreate ? 'pointer' : 'not-allowed',
                pointerEvents: canCreate ? 'auto' : 'none' // prevent click on disabled style
              }}
              disabled={!canCreate}
            >
              + Add State
            </button>
          </span>
        </OverlayTrigger>
      </div>

      <input
        type="text"
        className="form-control mb-3"
        placeholder="🔍 Search by State name"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <table className="table table-bordered align-middle text-center">
        <thead className="table-light">
          <tr>
            <th>No.</th>
            <th>Name</th>
            <th>Code</th>
            <th>Country</th>
            <th>Remarks</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {states
            .filter((s) => s.name.toLowerCase().includes(search.toLowerCase()))
            .map((s, i) => (
              <tr key={s._id}>
                <td>{i + 1}</td>
                <td>{s.name}</td>
                <td>{s.code}</td>
                <td>{s.country?.name || '-'}</td>
                <td>{s.remarks || '-'}</td>
                <td>
                  <div className="form-check form-switch d-flex justify-content-center">
                    <OverlayTrigger
                      placement="top"
                      overlay={renderTooltip(canEdit ? "Toggle status" : "No permission to change status")}
                    >
                      <span className="d-inline-block">
                        <input
                          className={`form-check-input ${s.status ? 'bg-success' : 'bg-danger'}`}
                          type="checkbox"
                          checked={s.status}
                          onChange={() => canEdit ? toggleStatus(s._id) : alert("No permission to change status")}
                          disabled={!canEdit}
                          title={canEdit ? "Toggle status" : "No permission to change status"}
                          style={{ cursor: canEdit ? 'pointer' : 'not-allowed' }}
                        />
                      </span>
                    </OverlayTrigger>
                  </div>
                </td>
                <td>
                  <OverlayTrigger
                    placement="top"
                    overlay={renderTooltip(canEdit ? "Edit" : "No permission to edit")}
                  >
                    <span className="d-inline-block me-2">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => canEdit ? navigate(`/add-state/${s._id}`) : alert("No permission to edit")}
                        disabled={!canEdit}
                        style={{ cursor: canEdit ? 'pointer' : 'not-allowed' }}
                      >
                        ✏️
                      </button>
                    </span>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement="top"
                    overlay={renderTooltip(canDelete ? "Delete" : "No permission to delete")}
                  >
                    <span className="d-inline-block">
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => canDelete ? handleDelete(s._id) : alert("No permission to delete")}
                        disabled={!canDelete}
                        style={{ cursor: canDelete ? 'pointer' : 'not-allowed' }}
                      >
                        🗑️
                      </button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
            ))}
          {states.length === 0 && (
            <tr>
              <td colSpan="7" className="text-center text-muted">No states found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StateList;
